export default __webpack_public_path__ + "static/media/cp_geo_am.6291e287.svg";